class ProductOptions extends HTMLElement {
    constructor() {
        super();
        this.isDispatchingEvent = false;
        
    }
    connectedCallback() {
        this.available_variants = [],
        this.container = this.querySelector(".product-options--container"),
        this.first_variant = JSON.parse(this.querySelector("[id*=variant-first--json]").innerHTML),
        this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]'),
        this.is_product_page = null !== this.closest(".product-page--root"),
        this.option_values = [],
        this.size_chart = this.querySelector(".product-options--option .product-size-chart--root"),
        this.variants = JSON.parse(this.querySelector("[id*=variant--json]").innerHTML),
        this.getVariantOptions(),
        this.hideOptions(this.first_variant, 0),
        this.disableEmptyOptions(),
        this.optionChangeListener(),
        this.size_chart && this.moveSizeChart()
    }
    disconnectedCallback() {
        this.inputs.off("change.ProductOptions")
    }
    getVariantOptions() {
        if (this.variants.forEach(t => t.available && this.available_variants.push(t.options)),
        0 < this.available_variants.length)
            for (let i = 0; i < this.available_variants[0].length; i++)
                this.option_values[i] = [...new Set(this.available_variants.map(t => t[i]))]
    }
    disableEmptyOptions() {
        const e = this.option_values.flat();
        this.container.querySelectorAll(".radios--input, .disclosure--option").forEach(t => {
            var i = this.getOptionValue(t);
            e.includes(i) || t.setAttribute("data-empty", !0)
        }
        )
    }

    findSelectAvailableOption(options) {
      if (options.length < 2 || this.isDispatchingEvent) return;
      
      const option1Value = options.find(o => o.index == '0').value;
      const availableOption2 = this.available_variants.find(o => o[0] == option1Value)[1];
      
      if(!availableOption2) return;

      const radioElement = this.container.querySelector(`[type="radio"][value="${availableOption2}"]`);
      if (!radioElement) {
        console.error(`Radio element not found for value: ${availableOption2}`);
        return;
      }

      this.isDispatchingEvent = true;
    
      // Dispatch the event
      radioElement.checked = true; // Set the element as checked
      radioElement.dispatchEvent(new Event('change', { bubbles: true }));

      this.isDispatchingEvent = false;
      
    }
  
    optionChangeListener() {
        this.inputs.forEach(input => 
            input.addEventListener("change", (event) => {
                const selections = [];
                this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked').forEach(selected => {
                    const index = selected.closest(".product-options--option").dataset.index;
                    selections.push({ index, value: selected.value });
                });

                this.hideOptions(selections.map(s => s.value), event.target.closest(".product-options--option").dataset.index);
                
                let matchedVariant = null;
                this.variants.every(variant => {
                    const isMatch = selections.every(sel => variant.options[sel.index] === sel.value);
                    if (isMatch) {
                        matchedVariant = variant;
                        return false;
                    }
                    return true;
                });

                this.updateVariant(matchedVariant);
                if(event.target.closest(".product-options--option").dataset.index == 0)
                  this.findSelectAvailableOption(selections);
            })
        );
    }
  
    updateVariant(t) {
        this.is_product_page && this.updateHistoryState(t.id),
        window.trigger(`theme:product:${this.dataset.id}:variantChanged`, {
            variant: t
        })
    }
    updateHistoryState(t) {
        let i = "" + location.origin + location.pathname;
        t && (i += "?variant=" + t),
        history.replaceState({
            path: i
        }, "", i)
    }
    hideOptions(a, i) {
        const s = 0 === this.option_values.length ? [] : a.map( (t, e) => this.option_values[e].filter(t => {
            const i = [...a];
            return i[e] = t,
            this.available_variants.some(t => t.join(",") === i.join(","))
        }
        ));
        this.container.childNodes.forEach( (t, e) => {
            e != i && t.querySelectorAll(".radios--input, .disclosure--option").forEach(t => {
                var i = this.getOptionValue(t);
                t.setAttribute("data-unavailable", !s[e].includes(i))
            }
            )
        }
        )
    }
    getOptionValue(t) {
        return t.getAttribute("data-value") ? t.getAttribute("data-value") : t.value
    }
    moveSizeChart() {
        this.size_chart.parentNode.querySelector("label").parentNode.appendChild(this.size_chart),
        this.size_chart.removeAttribute("style")
    }
}
const productOptionsEl = customElements.get("product-options-root");
productOptionsEl || customElements.define("product-options-root", ProductOptions);
